export var RenderParams;
(function (RenderParams) {
    RenderParams[RenderParams["Max_Active_Texture_Count"] = 0] = "Max_Active_Texture_Count";
    RenderParams[RenderParams["Max_Uniform_Count"] = 1] = "Max_Uniform_Count";
    RenderParams[RenderParams["Max_AnisoLevel_Count"] = 2] = "Max_AnisoLevel_Count";
    RenderParams[RenderParams["MAX_Texture_Size"] = 3] = "MAX_Texture_Size";
    RenderParams[RenderParams["MAX_Texture_Image_Uint"] = 4] = "MAX_Texture_Image_Uint";
    RenderParams[RenderParams["SHADER_CAPAILITY_LEVEL"] = 5] = "SHADER_CAPAILITY_LEVEL";
    RenderParams[RenderParams["FLOAT"] = 6] = "FLOAT";
    RenderParams[RenderParams["UNSIGNED_BYTE"] = 7] = "UNSIGNED_BYTE";
    RenderParams[RenderParams["BYTE"] = 8] = "BYTE";
    RenderParams[RenderParams["UNSIGNED_SHORT"] = 9] = "UNSIGNED_SHORT";
    RenderParams[RenderParams["MaxComputeElement"] = 10] = "MaxComputeElement";
})(RenderParams || (RenderParams = {}));
